import React from "react"
import styled from "styled-components"

import { BasicCard } from "components/common"

import { device } from "utils"

const FaxActivateForm = ({ url }) => {
  return (
    <StyledFaxActivateForm>
      <BasicCard>
        {/* <TextGroup title={title} /> */}

        <div className="iframeContainer">
          <iframe
            id="fax-activate"
            title="fax-activate"
            src={url}
            frameBorder="0"
          ></iframe>
        </div>
        <script src="//ramsey.tfaforms.net/js/iframe_resize_helper.js"></script>
      </BasicCard>
    </StyledFaxActivateForm>
  )
}

const StyledFaxActivateForm = styled.div`
  width: 100%;
  max-width: 700px;
  margin: 0 auto;

  --card-padding: var(--sp-16);

  --card-background: var(--highlight_2);
  @media ${device.laptop} {
    --card-padding: var(--sp-96);
  }

  .tgWrap {
    margin-bottom: var(--sp-16);
  }

  .iframeContainer {
    height: 3430px;
    width: 100%;

    @media ${device.laptop} {
      height: 3750px;
      /* height: 2630px; */
    }

    iframe {
      height: 100%;
      width: 100%;
    }
  }
`

export default FaxActivateForm
